import { useMutation, useQueryClient } from '@tanstack/react-query';
import { serverRequest } from '../../util/server_request';
import { notifyUser } from '../../util/util';
import { memberRequestKeys } from './useMemberRequests';
import { memberRequestSummaryKeys } from './useMemberRequestSummary';

export const useApproveMemberRequest = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ requestId, remark }) => {
      return await serverRequest('POST', 'members/gcb/request/approve', {
        requestId,
        remark,
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: memberRequestKeys.all });
      queryClient.invalidateQueries({ queryKey: memberRequestSummaryKeys.all });
      notifyUser('success', 'Request approved successfully', 'Success');
    },
    onError: (error) => {
      notifyUser('error', error, 'Error');
    },
  });
};
